/* sticky buy bar: scroll fallback (jumps via anchors skip IntersectionObserver) */
(function () {
  function init() {
    var sticky = document.querySelector('[data-sticky-buy]'), form = document.querySelector('.pdp-sec [data-product-form]');
    if (!sticky || !form) return;
    var ticking = false;
    function upd() { ticking = false; var show = form.getBoundingClientRect().bottom < 0; sticky.classList.toggle('is-visible', show); sticky.setAttribute('aria-hidden', String(!show)); document.body.classList.toggle('has-sticky', show); }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();

/* notification bubble: real sales from metafield, otherwise factual store notes */
(function () {
  function init() {
    var box = document.getElementById('vrnNote'), dataEl = document.getElementById('vrnNotesData');
    if (!box || !dataEl) return;
    var data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var store = { get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }, set: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} } };
    var cfg = data.cfg || {};
    var FIRST = (+cfg.first || 4) * 1000, SHOW = (+cfg.show || 6) * 1000, GAP = (+cfg.gap || 10) * 1000, MAX = +cfg.max || 40, PAUSE = (+cfg.pause || 3) * 60000;
    var offUntil = +(store.get('vrnNoteOffUntil') || 0);
    var ICONS = {
      truck: '<path d="M2.5 6.5h11v9h-11zM13.5 9.5h4l3 3v3h-7"/><circle cx="6.5" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/>',
      tag: '<path d="M3 12V4h8l10 10-8 8L3 12Z"/><circle cx="7.5" cy="8.5" r="1.4"/>',
      'return': '<path d="M4 9h11a5 5 0 0 1 0 10H8"/><path d="m8 5-4 4 4 4"/>',
      chat: '<path d="M20 12a8 8 0 0 1-11.6 7.1L4 20l1-4A8 8 0 1 1 20 12Z"/>',
      bag: '<path d="M5 7h14l-1.2 11.1a2 2 0 0 1-2 1.9H8.2a2 2 0 0 1-2-1.9L5 7Z"/><path d="M9 7V6a3 3 0 0 1 6 0v1"/>'
    };
    var svg = function (n) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (ICONS[n] || ICONS.bag) + '</svg>'; };
    var TL = function (c) { return (c / 100).toLocaleString('tr-TR', { maximumFractionDigits: 2 }) + ' TL'; };
    var ago = function (iso) {
      var m = Math.round((Date.now() - new Date(iso).getTime()) / 6e4);
      if (isNaN(m) || m < 0) return null;
      if (m < 2) return 'az önce'; if (m < 60) return m + ' dakika önce';
      var h = Math.round(m / 60); if (h < 24) return h + ' saat önce';
      return h < 48 ? 'dün' : null;
    };
    var items = [];
    (Array.isArray(data.sales) ? data.sales : []).forEach(function (s) {
      var t = s && s.at && ago(s.at); if (!t) return;
      items.push({ icon: 'bag', title: 'Yakın zamanda satın alındı', sub: (s.city ? s.city + ' · bir müşteri' : 'Bir müşteri'), text: s.product || '', time: t, img: s.image || null, url: s.url || '#' });
    });
    if (!items.length) {
      (data.notes || []).forEach(function (n) {
        var it = { icon: n.icon, title: n.title, sub: n.sub, text: (n.text || '').replace('{PRICE}', n.price ? TL(n.price) : ''), time: '', img: n.img, url: n.url };
        if (n.icon === 'truck') {
          var p = {}; new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Istanbul', weekday: 'short', hour: '2-digit', hour12: false }).formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
          if (p.weekday === 'Sun' || (+p.hour % 24) >= (data.cutoff || 16)) { it.title = 'Hızlı kargo'; it.text = 'Şimdi sipariş verin, ilk iş günü kargoya verilsin.'; }
        }
        items.push(it);
      });
    }
    if (!items.length) return;
    var $ = function (s) { return box.querySelector(s); };
    var i = +(store.get('vrnNoteIdx') || 0) % items.length, shown = 0, hideT, nextT;
    function busy() { return document.querySelector('[data-drawer].is-open, [data-menu].is-open, .lightbox.is-open'); }
    function show() {
      if (shown >= MAX) return;
      if (busy() || document.hidden) { nextT = setTimeout(show, 5000); return; }
      var it = items[i];
      $('[data-n-ic]').innerHTML = svg(it.icon); $('[data-n-title]').textContent = it.title;
      $('[data-n-sub]').textContent = it.sub || ''; $('[data-n-text]').textContent = it.text || ''; $('[data-n-time]').textContent = it.time || '';
      $('[data-n-link]').setAttribute('href', it.url || '#');
      if (/^https?:\/\/wa\.me/.test(it.url || '')) { $('[data-n-link]').setAttribute('target', '_blank'); $('[data-n-link]').setAttribute('rel', 'noopener'); } else { $('[data-n-link]').removeAttribute('target'); }
      var wrap = $('[data-n-imgwrap]');
      if (it.img) { $('[data-n-img]').src = it.img; wrap.hidden = false; box.classList.remove('vnote--noimg'); } else { wrap.hidden = true; box.classList.add('vnote--noimg'); }
      box.style.setProperty('--vnote-dur', (SHOW / 1000) + 's');
      box.hidden = false; void box.offsetWidth; box.classList.add('is-in');
      shown++; i = (i + 1) % items.length; store.set('vrnNoteIdx', String(i));
      hideT = setTimeout(hide, SHOW);
    }
    function hide() { box.classList.remove('is-in'); setTimeout(function () { box.hidden = true; }, 350); nextT = setTimeout(show, GAP); }
    $('[data-n-close]').addEventListener('click', function () { clearTimeout(hideT); clearTimeout(nextT); box.classList.remove('is-in'); setTimeout(function () { box.hidden = true; }, 350); store.set('vrnNoteOffUntil', String(Date.now() + PAUSE)); nextT = setTimeout(show, PAUSE); });
    box.addEventListener('mouseenter', function () { clearTimeout(hideT); box.classList.add('is-paused'); });
    box.addEventListener('mouseleave', function () { box.classList.remove('is-paused'); if (box.classList.contains('is-in')) hideT = setTimeout(hide, 3000); });
    nextT = setTimeout(show, Math.max(FIRST, offUntil - Date.now()));
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
